import * as React from "react";
import ButtonSwitch from "../../ButtonSwitch";
import MaterialCustomSelectDate from "../../../features/SmartFilters/MaterialCustomSelectDate";
import { useHubx } from "../../../HubX";
import {
  EVENT_INSTALLATION_SPLIT_LEVEL_TANKS_CHANGE,
  EVENT_INSTALLATION_LEVEL_FILTER_DATE_CHANGE,
} from "../../../Events";

type LevelFilterProps = {
  hasMoreThanOneTank?: boolean;
};

function LevelFilter(props: LevelFilterProps) {
  const { hasMoreThanOneTank } = props;
  const [splitTanks, setSplitTanks] = React.useState(false);

  const hub = useHubx();

  const handleClick = (newValue: boolean) => {
    hub.notify(EVENT_INSTALLATION_SPLIT_LEVEL_TANKS_CHANGE, newValue);
    setSplitTanks(newValue);
  };

  React.useEffect(() => {
    if (!hasMoreThanOneTank) {
      setSplitTanks(false);
    }
  }, [hasMoreThanOneTank]);

  return (
    <>
      {hasMoreThanOneTank && (
        <ButtonSwitch label="Separar Tanques" value={splitTanks} onClick={handleClick} />
      )}

      <MaterialCustomSelectDate event={EVENT_INSTALLATION_LEVEL_FILTER_DATE_CHANGE} />
    </>
  );
}

export default LevelFilter;
